import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { FaTachometerAlt } from 'react-icons/fa';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input/Input';
import AssignmentGrid from '../../components/AssignmentGrid/AssignmentGrid';

const EvaluationTypeForm = ({ handleChange, onInputChange, onSwitchChange, handleSubmit,
  name, isLoader, scoreSchemeList, score_scheme_ids }) => {
  return (
    <Form onSubmit={handleSubmit}>
      {isLoader && <div className="loader"><Loader /></div>}
      <div className="row">
        <div className="col-md-12 mb-3">
          <Input
            label="Evaluation Name"
            type="text"
            name="name"
            onChangeHandler={handleChange}
            placeholder="Enter Evaluation name"
            value={name}
            required={true}
          />
        </div>

        <AssignmentGrid
          label="Select Score Schemes"
          icon={<FaTachometerAlt />}
          items={scoreSchemeList}
          selectedIds={score_scheme_ids}
          onToggle={onInputChange}
          onSelectAll={onSwitchChange}
          switchName="score_scheme_ids"
        />

        <div className="col-md-12 mt-4 d-flex justify-content-end">
          <Button variant="success"
            disabled={isLoader}
            type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default EvaluationTypeForm;
